import React, { useRef, useState, useEffect, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import TrustpilotStars from "../Components/TrustpilotStars";
import GoogleRatingStars from "../Components/GoogleRatingStars";
import HomeVideoModal from "../Components/HomeVideo";
import FeedbackSlider from "../Components/ReviewSlider";
import PlanList from "../Components/PlanList";
import SponserSlider from "../Components/SponserSlider";
import MinPlanPrice from "../Components/MinPlanPrice";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../utils/ScrollToPlan";
import CouponScrollBar from "../Components/CouponScrollBar";



export default function Home() {
    const nextRef = useRef(null);
    const prevRef = useRef(null);
    const [applyPaddingClass, setApplyPaddingClass] = useState(false);
    const [showContent, setShowContent] = useState(false);
    useEffect(() => {
        if (typeof window !== "undefined") {
            document.title = "Best Website Hosting Services | 24/7 Support";

            // delay SAL
            setTimeout(() => {
                import("sal.js").then(({ default: sal }) => {
                    sal();
                });
            }, 2000);

            // 🔥 THIS IS THE KEY FIX
            setTimeout(() => {
                setShowContent(true);
            }, 500); // small delay
        }
    }, []);

    const handlePlanClick = () => {
        ScrollToPlans(".price-plan-section");
        };


    return(
        <>
        <Helmet>
            <title>Best Website Hosting Services | 24/7 Support</title>
            <meta name="description" content="Get the best website hosting service with fast SSD servers, strong security, reliable uptime, and 24/7 expert support for all websites." />
            <meta name="keywords" content="Best Web Hosting, Best Website Hosting, Website Hosting Companies, Best Hosting Services, Best Web Hosting Services, Web Hosting Providers, Top Hosting Providers, Top Web Hosting, Buy Web Hosting, Best Hosting Company, Best Website Hosting Service, Best Web Hosting Companies, The Best Web Hosting, Web Hosting " />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}`} />
            <meta property="og:title" content="Secure & Affordable Hosting Platform For Your Needs" />
            <meta property="og:description" content="Infinitive Host started in 2017 with the aim of providing better hosting services to clients. We have designed customized and affordable web hosting plans for our clients." />
        </Helmet>

        <section className="hero-1 pb-32 bg-dark position-relative z-1 overflow-hidden">
            <div className="container banner-wrapper">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-10 col-xl-7">
                        <div className="fs-14 text-white">
                            <div className="d-flex align-items-center gap-3" data-sal="fade" data-sal-duration="100" data-sal-easing="ease-in-out-sine">
                                <span><i className='fa-solid fa-star text-warning' style={{fontSize: '22px'}}></i></span>
                                <span>
                                    All-in-One Web Hosting Provider
                                </span>
                            </div>
                        </div>
                        <h1 className="text-white mt-1">Serious Tasks<span className="text-warning d-inline-block">.</span>Need Serious GPU Dedicated Server</h1>
                        <p className="text-white mt-5 max-text-68 mb-8" data-sal="fade" data-sal-duration="100"
                            data-sal-easing="ease-in-out-sine">Get a high-performance GPU Dedicated server with a <span className="text-success">99.9%</span> uptime guarantee, Unlimited bandwidth, and much more. Yeah, that’s what your site wants: high power, performance, speed, and reliability all in one place!</p>
                        <div className="d-flex align-items-center gap-6 flex-wrap" data-sal="fade" data-sal-duration="100" data-sal-easing="ease-in-out-sine">
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" data-discover="true">
                                <span className="btn-arrow__text">Get Started
                                    <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </button>
                            <Link to="tel:7737300013"
                                className="btn btn-light btn-arrow fs-14 fw-semibold rounded transition btn-height">
                                <span className="btn-arrow__text">
                                     +91-7737300013
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                            {showContent && <MinPlanPrice category="customizedgdsusa" />}
                        </div>
                        <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                    </div>
                    <div className="col-xl-5">
                        <img src="images/hosting-img.webp" alt="" className="banner-img img-fluid w-auto" width="600" height="400" fetchPriority="high"/>
                    </div>
                </div>
            </div>
        </section>

        <section className="domain-container position-relative z-1 overflow-hidden">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10">
                        <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                            <div className="card-body pt-60 pb-60">
                                <div className="row justify-content-center">
                                    <div className="col-lg-11 text-center">
                                        <span className="section-title high-contrast style-bg fadeInUp mb-4" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Ranking & Ratings</span>
                                        <h2 className="text-center h4 mb-4" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Ratings Across Platforms</h2>
                                        <p className="text-center mb-5 pb-5" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">See what our customers have to say about us across various platforms like Trustpilot and Google. We pride ourselves on delivering exceptional service, and our reviews reflect the trust and satisfaction of our clients.</p>
                                        <div className="row" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                                <Link to="https://www.trustpilot.com/review/infinitivehost.com" target="_blank">
                                                <div className="review-card">
                                                    <h4 className="main-rating">4.5 <span className="sm-text">/5</span></h4>
                                                    {showContent && <TrustpilotStars />}
                                                    <img className="rating-logo mt-4 img-fluid w-auto" src="images/trustpilot.webp" alt="" width="135" height="34" />
                                                </div>
                                                </Link>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                                <Link to="https://www.google.com/maps/place/Infinitive+Host+Technologies+Pvt.+Ltd./@26.8953422,75.7485232,17z/data=!3m1!4b1!4m6!3m5!1s0x396db35c78aeff41:0x196bf2f9e5604064!8m2!3d26.8953422!4d75.7485232!16s%2Fg%2F11g8741hg9?entry=ttu" target="_blank">
                                                <div className="review-card">
                                                    <h4 className="main-rating">4.8 <span className="sm-text">/5</span></h4>
                                                    {showContent && <GoogleRatingStars rating={4.8} />}
                                                    <img className="rating-logo mt-4 img-fluid w-auto" src="images/google-1.png" alt="" width="135" height="34" />
                                                </div>
                                                </Link>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-6">
                                                <Link to="https://hostadvice.com/hosting-company/infinitivehost-reviews/" target="_blank">
                                                <div className="review-card">
                                                    <h4 className="main-rating">5.0 <span className="sm-text">/5</span></h4>
                                                    {showContent && <GoogleRatingStars rating={5} />}
                                                    <img className="rating-logo mt-4 img-fluid  w-auto" src="images/hostadvice-1.png" alt="" width="135" height="34" />
                                                </div>
                                                </Link>
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-6">
                                                <Link to="https://www.hostingseekers.com/company/infinitive-host/detail" target="_blank">
                                                <div className="review-card">
                                                    <h4 className="main-rating">5.0 <span className="sm-text">/5</span></h4>
                                                    {showContent && <GoogleRatingStars rating={5} />}
                                                    <img className="rating-logo mt-4 img-fluid w-auto" src="images/hosting-seeker.png" alt="" width="135" height="34" />
                                                </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    
        <section className="service-area pt-120 pb-120">
            <div className="pb-40">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7">
                            <span className="section-title high-contrast style-bg fadeInUp">Our Services</span>
                            <h2 className="mb-0" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                data-sal-easing="ease-in-out-sine">From Scratch to Success: Build, Host & Dominate</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row g-4">
                    <div className="col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                                <img className="service-figure-1" src="images/feature-shape-1.webp" alt="" />
                            <div className="card-body px-md-7 py-md-8">
                                <div className="row align-items-center g-4 d-grid">
                                    <div className="col-md-4">
                                        <img className="service-img img-fluid w-auto" src="images/gpu-dedicated-server.webp" alt="" width="80" height="80" />
                                    </div>
                                    <div className="col-md-12">
                                        <h6 className="mb-4">GPU Dedicated Server</h6>
                                        <p className="mb-5 pb-2">Completely reliable server development for high-end performance. No delay, no stress.</p>
                                        <Link to="/gpu-dedicated-server-usa" className="btn theme-blue-btn btn-arrow btn-arrow-sm fs-14 fw-medium rounded btn-height">
                                            <span className="btn-arrow__text">
                                                View More
                                                <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                                </span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                            <img className="service-figure-1" src="images/feature-shape-1.webp" alt="" />
                            <div className="card-body px-md-7 py-md-8">
                                <div className="row align-items-center g-4 d-grid">
                                    <div className="col-md-4">
                                        <img className="service-img img-fluid w-auto" src="images/odoo-solutions.webp" alt="" width="80" height="80" />
                                    </div>
                                    <div className="col-md-12">
                                        <h6 className="mb-4">Odoo Solutions</h6>
                                        <p className="mb-5 pb-2">Customized odoo solutions that fulfill all your business requirements and goals flawlessly.</p>
                                        <Link to="/odoo-server" className="btn theme-blue-btn btn-arrow btn-arrow-sm fs-14 fw-medium rounded btn-height">
                                            <span className="btn-arrow__text">
                                                View More
                                                <span className="btn-arrow__icon">
                                                    <i className="fa-solid fa-arrow-right"></i>
                                                </span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>WordPress Hosting</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img w-auto" src="images/wordpress-hosting.webp" alt="" width="70" height="70" />
                                    </div>
                                    <div>
                                        <p>WordPress hosting is enhanced for high speed, unbeatable security, & exceptional performance.</p>
                                        <Link to="wordpress-hosting" className="arrow-btn d-grid place-content-center w-8 h-8 rounded-circle transition" aria-label="View WordPress Hosting">
                                            <span className="fs-16 d-inline-block">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Cloud Hosting</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img w-auto" src="images/streaming-servers.webp" alt="" width="70" height="70" />
                                    </div>
                                    <div>
                                        <p>Launch your website's online journey with high-end cloud hosting.</p>
                                        <Link to="/cloud-hosting" className="arrow-btn d-grid place-content-center w-8 h-8 rounded-circle transition" aria-label="View Cloud Hosting">
                                            <span className="fs-16 d-inline-block">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Dedicated Server</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img w-auto" src="images/dedicated-server.webp" alt="" width="70" height="70" />
                                    </div>
                                    <div>
                                        <p>Get exceptional performance with stable and cutting-edge dedicated servers.</p>
                                        <Link to="/dedicated-server-new-york" className="arrow-btn d-grid place-content-center w-8 h-8 rounded-circle transition" aria-label="View Dedicated Server">
                                            <span className="fs-16 d-inline-block">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>VPS Hosting</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img w-auto" src="images/vps-hosting.webp" alt="" width="70" height="70" />
                                    </div>
                                    <div>
                                        <p>Advanced SSD-based servers with exceptional scalability that you can easily trust.</p>
                                        <Link to="/windows-cloud-vps" className="arrow-btn d-grid place-content-center w-8 h-8 rounded-circle transition" aria-label="View VPS Hosting">
                                            <span className="fs-16 d-inline-block">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Streaming Servers </h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img w-auto" src="images/cloud-hosting-1.webp" alt="" width="70" height="70" />
                                    </div>
                                    <div>
                                        <p>Unlimited streaming-advanced servers for flawless live and VOD streaming.</p>
                                        <Link to="/streaming-server-new-york" className="arrow-btn d-grid place-content-center w-8 h-8 rounded-circle transition" aria-label="View Streaming Servers">
                                            <span className="fs-16 d-inline-block">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                            data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Reseller Hosting</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img className="small-service-img w-auto" src="images/reseller-hosting.webp" alt="" width="70" height="70" />
                                    </div>
                                    <div>
                                        <p>Robust and reliable hosting solutions for seamless business growth.</p>
                                        <Link to="/linux-reseller-hosting" className="arrow-btn d-grid place-content-center w-8 h-8 rounded-circle transition" aria-label="View Reseller Hosting">
                                            <span className="fs-16 d-inline-block">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    
        <section className="price-plan-section pt-100 pb-100">
            {showContent && <CouponScrollBar setPaddingClass={setApplyPaddingClass} />}
            <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8">
                            <div className="text-center">
                                <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                                <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Your Plan - Your Hosting</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showContent && <PlanList category={'wordpress-hosting'}/>}
        </section>
    
        <section className="why-area-one bg-dark pt-120 pb-120 position-relative z-1">
            <div className="container">
                <div className="row align-items-center justify-content-between">
                    <div className="col-xl-7 col-lg-8">
                        <span className="section-title-dark style-bg fadeInUp">Choose Us</span>
                        <h2 className="text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Powerful & Secure : Web Hosting You Can’t Miss</h2>
                    </div>
                </div>
                <div className="mt-8">
                    <div className="row g-4">
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/hosting-that-always.webp" alt="image" className="img-fluid w-auto" width="56" height="56" />
                                <img src="images/hosting-that-always-dark.webp" alt="image" className="img-fluid dark w-auto" width="56" height="56" />
                                <h6 className="can-miss-title text-white mt-7">Hosting That Always Scales with You</h6>
                                <p className="text-white text-opacity-75 mb-0">Slow speed? Get high-speed servers, robust performance, constant support, and ideal scalability, which will constantly boost your growth.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/worldwide-level.webp" alt="image" className="img-fluid w-auto" width="56" height="56" />
                                <img src="images/worldwide-level-dark.webp" alt="image" className="img-fluid dark w-auto" width="56" height="56" />
                                <h6 className="can-miss-title text-white mt-7">Worldwide-Level Reach, Local Reliability</h6>
                                <p className="text-white text-opacity-75 mb-0">Strategic servers across the US, India, and Europe guarantee high uptime & high performance-keeping your site always up and seamlessly running.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/support-that’s-always.webp" alt="image" className="img-fluid w-auto" width="56" height="56" />
                                <img src="images/support-that’s-always-dark.webp" alt="image" className="img-fluid dark w-auto" width="56" height="56" />
                                <h6 className="can-miss-title text-white mt-7">Support That’s Always Have Your Back</h6>
                                <p className="text-white text-opacity-75 mb-0">Get professional guidance with 24/7 Skype support and many more-ensuring smooth GPU hosting, etc., and a hassle-free experience, anytime you want it.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/reliable-protection.webp" alt="image" className="img-fluid w-auto" width="56" height="56" />
                                <img src="images/reliable-protection-dark.webp" alt="image" className="img-fluid dark w-auto" width="56" height="56" />
                                <h6 className="can-miss-title text-white mt-7">Reliable Protection, Powerful Performance</h6>
                                <p className="text-white text-opacity-75 mb-0">Tier 4 data centers and cutting-edge security measures always keep your servers protected from all threats so that you can only focus on what truly matters.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/advanced-technology.webp" alt="image" className="img-fluid w-auto" width="56" height="56" />
                                <img src="images/advanced-technology-dark.webp" alt="image" className="img-fluid dark w-auto" width="56" height="56" />
                                <h6 className="can-miss-title text-white mt-7">Advanced Technology for High Speed</h6>
                                <p className="text-white text-opacity-75 mb-0">Powerful infrastructure guarantees 24/7 expert support, robust security, and 10x faster performance, keeping you in the lead of the competitive era.</p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                            <div className="why-card px-6 py-9 rounded-3 transition h-100">
                                <img src="images/stress-free-migration.webp" alt="image" className="img-fluid w-auto" width="56" height="56" />
                                <img src="images/stress-free-migration-dark.webp" alt="image" className="img-fluid dark w-auto" width="56" height="56" />
                                <h6 className="can-miss-title text-white mt-7">Stress-Free Migration With No Downtime</h6>
                                <p className="text-white text-opacity-75 mb-0">Flawlessly move your all data with no downtime and no risk. Get a highly-secure data transfer & keep your site always running without interruption!</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-20">
                    <div className="row g-4">
                        <div className="col-md-3 col-6">
                            <div className="why-service-item text-center position-relative" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <img className="about-us-img mb-3" src="images/6000-clients.webp" alt="" />
                                <h5 className="text-white mb-3"><span className="counter">6000+</span></h5>
                                <p className="text-white text-opacity-75">Clients</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="why-service-item text-center position-relative" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <img className="about-us-img mb-3" src="images/2017-established.webp" alt="" />
                                <h5 className="text-white mb-3"><span className="counter">2017</span></h5>
                                <p className="text-white text-opacity-75">Established</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="why-service-item text-center position-relative" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <img className="about-us-img mb-3" src="images/11-data-centers.webp" alt="" />
                                <h5 className="text-white mb-3"><span className="counter">11+</span></h5>
                                <p className="text-white text-opacity-75">Data Centers</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="why-service-item last text-center position-relative" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <img className="about-us-img mb-3" src="images/client-satisfaction.webp" alt="" />
                                <h5 className="text-white mb-3"><span className="counter">100%</span></h5>
                                <p className="text-white text-opacity-75">Client Satisfaction</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    
        <section className="video-area-one pt-120 pb-60 position-relative z-0">
            <div className="pb-40">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8">
                            <div className="text-center">
                                <span className="section-title-dark style-bg fadeInUp">Our Vision</span>
                                <h2 className="text-white mb-0" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                    data-sal-easing="ease-in-out-sine">Innovative Solutions for Your Business
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="bg-white p-3 shadow-lg rounded position-relative" data-sal="slide-up"
                            data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <img src="images/home-video-thumb.jpg" alt="" className="img-fluid w-100" width="832" height="468" />
                            <a href="javascript:void(0);" className="video-btn popup-init position-absolute top-50 start-50 translate-middle" data-bs-toggle="modal" data-bs-target="#myModal" aria-label="View Podcast Video">
                                <span className="w-16 h-16 rounded-circle d-flex align-items-center justify-content-center bg-primary">
                                    <span className="text-white fs-5">
                                        <i className="fa-solid fa-play"></i>
                                    </span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    
        <section className="pt-60 pb-60">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-8">
                        <span className="section-title high-contrast style-bg fadeInUp">Reviews</span>
                        <h2
                        data-sal="slide-up"
                        data-sal-duration="500"
                        data-sal-delay="200"
                        data-sal-easing="ease-in-out-sine"
                        >
                        Voices of Clients-Hear How We Stand Out!
                        </h2>
                    </div>
                </div>

                {showContent && <FeedbackSlider />}
            </div>
        </section>
        
        <section className="bg-dark pt-100 pb-100">
            <div className="pb-40">
                <div className="container">
                    <div className="row g-4 justify-content-between align-items-center">
                        <div className="col-xxl-5 col-xl-7 col-lg-8">
                            <span className="section-title-dark style-bg fadeInUp">Our Clients</span>
                            <h2 className="text-white mb-2">Powerful Together, Booming Forever!</h2>
                            <p className="text-white mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">We Our partnerships are built on reliability and a mutual vision for business success. With the help of seamless GPU dedicated server solutions, we help harness new possibilities for your growth.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    {showContent && <SponserSlider />}
                </div>
            </div>
        </section>

        <section className="bg-dark pt-60 pb-100 map-section">
            <div className="pb-60">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-8 col-xl-7">
                            <div className="text-center">
                                <span className="section-title-dark style-bg fadeInUp">Business Worldwide</span>
                                <h2 className="h3 text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Connected Globally, Powered Locally</h2>
                                <p className="text-white mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">We expand without any limits-our worldwide data centers always keep your business running seamlessly.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="700" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="map-img-wrapper">
                                <img className="img-fluid data-center__map blend-mode-dodge" src="images/map.webp" alt="image"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="pt-100 pb-80">
            <div className="container">
                <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                    <div className="row justify-content-center">
                        <div className="col-xxl-7 col-xl-9">
                            <div className="d-flex justify-content-center" data-sal="slide-up" data-sal-duration="500"
                                data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                    <span className="section-title style-bg fadeInUp">Host With Infinitive Host</span>
                            </div>
                            <div className="text-center">
                                <h2 className="mb-5 h4" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                    data-sal-easing="ease-in-out-sine">Are you ready to host your website?</h2>
                                <p className="mb-8" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                    data-sal-easing="ease-in-out-sine">Begin your journey with India’s most reliable web hosting provider now! <br /> Connect with our expert instantly for call or chat support and host your favourite server now.</p>
                            </div>
                            <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap"
                                data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                                data-sal-easing="ease-in-out-sine">
                                <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                    <span className="btn-arrow__text">
                                         +91-7737300013
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                                <Link to="#" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded open-live-chat btn-height">
                                    <span className="btn-arrow__text">
                                        Talk To An Expert
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        {showContent && <HomeVideoModal />}
        </>
    )
}